import React, { ChangeEventHandler, FC } from "react";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";
import useTheme from "evcharging/hooks/useTheme";

interface RatesInputProps {
  value: string;
  label: string;
  placeholder: string;
  onChange: (value: string) => void;
}

const RatesInput: FC<RatesInputProps> = (props) => {
  const { value, label, placeholder, onChange } = props;
  const theme = useTheme();
  const styles = createStyles(theme);

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className={styles.root}>
      <label className={styles.label}>{label}</label>
      <input
        className={styles.input}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
      />
    </div>
  );
};

const createStyles = (theme: Theme) => (
  {
    root: css`
      border-color: #d3d5dc;
      border-style: solid;
      border-width: 1px;
      background-color: #fff;
      border-radius: 6px;
      padding: 6px 16px;

      > * {
        font-family: Mulish, sans-serif;
      }
    `,
    label: css`
      width: 100%;
      color: #909090;
      font-size: 14px;
      font-weight: 500;
      line-height: 19px;
    `,
    input: css`
      border: none;
      color: #000;
      width: 100%;
      font-size: 16px;
      font-weight: 600;
      line-height: 19px;
      letter-spacing: 0.5px;
    `
  }
);

export default RatesInput;